export default {
  salaryManagement: {
    getAssignableApiUrl:
      "payroll/payment-management/settings/approver-settings",
    getApiUrl: "payroll/payment-management/settings/approver-settings",
    createApiUrl: "payroll/payment-management/settings/approver-settings",
    editApiUrl: "payroll/payment-management/settings/approver-settings",
    getOneApiUrl: "payroll/payment-management/settings/approver-settings",
    deleteApiUrl: "payroll/payment-management/settings/approver-settings",
    assignableApiUrl: "payroll/payment-management/settings/approver-settings",
    settings: "/admin/payroll/salary-management/settings",
    redirectUrl: "/admin/payroll/salary-management/settings/approvers",
  },
  mobileClocks: {
    getAssignableApiUrl: "attendance/mobile-clocks/settings/approver-settings",
    getApiUrl: "attendance/mobile-clocks/settings/approver-settings",
    createApiUrl: "attendance/mobile-clocks/settings/approver-settings",
    editApiUrl: "attendance/mobile-clocks/settings/approver-settings",
    getOneApiUrl: "attendance/mobile-clocks/settings/approver-settings",
    deleteApiUrl: "attendance/mobile-clocks/settings/approver-settings",
    assignableApiUrl: "attendance/mobile-clocks/settings/approver-settings",
    settings: "/admin/attendance/mobile-clocks/settings",
    redirectUrl: "/admin/attendance/mobile-clocks/settings/approvers",
  },
  loanRequest: {
    getAssignableApiUrl: "payroll/loans/settings/approver-settings",
    getApiUrl: "payroll/loans/settings/approver-settings",
    createApiUrl: "payroll/loans/settings/approver-settings",
    editApiUrl: "payroll/loans/settings/approver-settings",
    getOneApiUrl: "payroll/loans/settings/approver-settings",
    deleteApiUrl: "payroll/loans/settings/approver-settings",
    assignableApiUrl: "payroll/loans/settings/approver-settings",
    settings: "/admin/payroll/loan/settings",
    redirectUrl: "/admin/payroll/loan/settings/approvers",
  },
  benefitAndDeduction: {
    getAssignableApiUrl:
      "payroll/benefit-and-deduction/settings/approver-settings",
    getApiUrl: "payroll/benefit-and-deduction/settings/approver-settings",
    createApiUrl: "payroll/benefit-and-deduction/settings/approver-settings",
    editApiUrl: "payroll/benefit-and-deduction/settings/approver-settings",
    getOneApiUrl: "payroll/benefit-and-deduction/settings/approver-settings",
    deleteApiUrl: "payroll/benefit-and-deduction/settings/approver-settings",
    assignableApiUrl:
      "payroll/benefit-and-deduction/settings/approver-settings",
    settings: "/admin/payroll/benefit-deduction/settings",
    redirectUrl: "/admin/payroll/benefit-deduction/settings/approvers",
  },
  performanceAppraisal: {
    getAssignableApiUrl: "hrm/appraisals/settings/approver-settings",
    getApiUrl: "hrm/appraisals/settings/approver-settings",
    createApiUrl: "hrm/appraisals/settings/approver-settings",
    editApiUrl: "hrm/appraisals/settings/approver-settings",
    getOneApiUrl: "hrm/appraisals/settings/approver-settings",
    deleteApiUrl: "hrm/appraisals/settings/approver-settings",
    assignableApiUrl: "hrm/appraisals/settings/approver-settings",
    settings: "/admin/performance/appraisal/settings",
    redirectUrl: "/admin/performance/appraisal/settings/approvers",
  },
};
